import * as Types from '../../../../__generated__/base.gql';

import { gql } from '@apollo/client';
import { QueuePatientFragmentFragmentDoc } from '../../../patient-queue-management/_lib/__generated__/queries.gql';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type PatientQueueFragmentFragment = { readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string };

export type PatientQueueWithPatientsFragmentFragment = { readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string, readonly patients: ReadonlyArray<{ readonly __typename?: 'PatientOfQueue', readonly uuid: string, readonly fullname: string, readonly gender: Types.Gender, readonly addedAt: string, readonly triageStatus?: { readonly __typename?: 'TriageStatusOfQueue', readonly _id: string, readonly currentStatus?: string | null, readonly expiresAt?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null } | null } | null> };

export type QueryForPatientQueryVariables = Types.Exact<{
  patientUuid: Types.Scalars['ID'];
}>;


export type QueryForPatientQuery = { readonly __typename?: 'Query', readonly queueForPatient?: { readonly __typename?: 'PatientQueue', readonly _id: string } | null };

export type PatientQueueDropdownQueryVariables = Types.Exact<{
  patientUuid: Types.Scalars['ID'];
}>;


export type PatientQueueDropdownQuery = { readonly __typename?: 'Query', readonly facilityQueues: ReadonlyArray<{ readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string } | null>, readonly queueForPatient?: { readonly __typename?: 'PatientQueue', readonly _id: string } | null };

export type AddQueuePatientMutationVariables = Types.Exact<{
  input: Types.AddQueuePatientInput;
}>;


export type AddQueuePatientMutation = { readonly __typename?: 'Mutation', readonly addQueuePatient: { readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string, readonly patients: ReadonlyArray<{ readonly __typename?: 'PatientOfQueue', readonly uuid: string, readonly fullname: string, readonly gender: Types.Gender, readonly addedAt: string, readonly triageStatus?: { readonly __typename?: 'TriageStatusOfQueue', readonly _id: string, readonly currentStatus?: string | null, readonly expiresAt?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null } | null } | null> } };

export type RemoveQueuePatientMutationVariables = Types.Exact<{
  input: Types.RemoveQueuePatientInput;
}>;


export type RemoveQueuePatientMutation = { readonly __typename?: 'Mutation', readonly removeQueuePatient: { readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string, readonly patients: ReadonlyArray<{ readonly __typename?: 'PatientOfQueue', readonly uuid: string, readonly fullname: string, readonly gender: Types.Gender, readonly addedAt: string, readonly triageStatus?: { readonly __typename?: 'TriageStatusOfQueue', readonly _id: string, readonly currentStatus?: string | null, readonly expiresAt?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null } | null } | null> } };

export type MoveQueuePatientMutationVariables = Types.Exact<{
  input: Types.MoveQueuePatientInput;
}>;


export type MoveQueuePatientMutation = { readonly __typename?: 'Mutation', readonly moveQueuePatient: { readonly __typename?: 'PatientQueue', readonly _id: string, readonly name: string, readonly patients: ReadonlyArray<{ readonly __typename?: 'PatientOfQueue', readonly uuid: string, readonly fullname: string, readonly gender: Types.Gender, readonly addedAt: string, readonly triageStatus?: { readonly __typename?: 'TriageStatusOfQueue', readonly _id: string, readonly currentStatus?: string | null, readonly expiresAt?: string | null, readonly createdAt?: string | null, readonly updatedAt?: string | null } | null } | null> } };

export const PatientQueueFragmentFragmentDoc = gql`
    fragment PatientQueueFragment on PatientQueue {
  _id
  name
}
    `;
export const PatientQueueWithPatientsFragmentFragmentDoc = gql`
    fragment PatientQueueWithPatientsFragment on PatientQueue {
  _id
  name
  patients {
    ...QueuePatientFragment
  }
}
    ${QueuePatientFragmentFragmentDoc}`;
export const QueryForPatientDocument = gql`
    query QueryForPatient($patientUuid: ID!) {
  queueForPatient(input: {patientUuid: $patientUuid}) {
    _id
  }
}
    `;

/**
 * __useQueryForPatientQuery__
 *
 * To run a query within a React component, call `useQueryForPatientQuery` and pass it any options that fit your needs.
 * When your component renders, `useQueryForPatientQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useQueryForPatientQuery({
 *   variables: {
 *      patientUuid: // value for 'patientUuid'
 *   },
 * });
 */
export function useQueryForPatientQuery(baseOptions: Apollo.QueryHookOptions<QueryForPatientQuery, QueryForPatientQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<QueryForPatientQuery, QueryForPatientQueryVariables>(QueryForPatientDocument, options);
      }
export function useQueryForPatientLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<QueryForPatientQuery, QueryForPatientQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<QueryForPatientQuery, QueryForPatientQueryVariables>(QueryForPatientDocument, options);
        }
export type QueryForPatientQueryHookResult = ReturnType<typeof useQueryForPatientQuery>;
export type QueryForPatientLazyQueryHookResult = ReturnType<typeof useQueryForPatientLazyQuery>;
export type QueryForPatientQueryResult = Apollo.QueryResult<QueryForPatientQuery, QueryForPatientQueryVariables>;
export const PatientQueueDropdownDocument = gql`
    query PatientQueueDropdown($patientUuid: ID!) {
  facilityQueues {
    ...PatientQueueFragment
  }
  queueForPatient(input: {patientUuid: $patientUuid}) {
    _id
  }
}
    ${PatientQueueFragmentFragmentDoc}`;

/**
 * __usePatientQueueDropdownQuery__
 *
 * To run a query within a React component, call `usePatientQueueDropdownQuery` and pass it any options that fit your needs.
 * When your component renders, `usePatientQueueDropdownQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePatientQueueDropdownQuery({
 *   variables: {
 *      patientUuid: // value for 'patientUuid'
 *   },
 * });
 */
export function usePatientQueueDropdownQuery(baseOptions: Apollo.QueryHookOptions<PatientQueueDropdownQuery, PatientQueueDropdownQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PatientQueueDropdownQuery, PatientQueueDropdownQueryVariables>(PatientQueueDropdownDocument, options);
      }
export function usePatientQueueDropdownLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PatientQueueDropdownQuery, PatientQueueDropdownQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PatientQueueDropdownQuery, PatientQueueDropdownQueryVariables>(PatientQueueDropdownDocument, options);
        }
export type PatientQueueDropdownQueryHookResult = ReturnType<typeof usePatientQueueDropdownQuery>;
export type PatientQueueDropdownLazyQueryHookResult = ReturnType<typeof usePatientQueueDropdownLazyQuery>;
export type PatientQueueDropdownQueryResult = Apollo.QueryResult<PatientQueueDropdownQuery, PatientQueueDropdownQueryVariables>;
export const AddQueuePatientDocument = gql`
    mutation AddQueuePatient($input: AddQueuePatientInput!) {
  addQueuePatient(input: $input) {
    ...PatientQueueWithPatientsFragment
  }
}
    ${PatientQueueWithPatientsFragmentFragmentDoc}`;
export type AddQueuePatientMutationFn = Apollo.MutationFunction<AddQueuePatientMutation, AddQueuePatientMutationVariables>;

/**
 * __useAddQueuePatientMutation__
 *
 * To run a mutation, you first call `useAddQueuePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddQueuePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addQueuePatientMutation, { data, loading, error }] = useAddQueuePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddQueuePatientMutation(baseOptions?: Apollo.MutationHookOptions<AddQueuePatientMutation, AddQueuePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddQueuePatientMutation, AddQueuePatientMutationVariables>(AddQueuePatientDocument, options);
      }
export type AddQueuePatientMutationHookResult = ReturnType<typeof useAddQueuePatientMutation>;
export type AddQueuePatientMutationResult = Apollo.MutationResult<AddQueuePatientMutation>;
export type AddQueuePatientMutationOptions = Apollo.BaseMutationOptions<AddQueuePatientMutation, AddQueuePatientMutationVariables>;
export const RemoveQueuePatientDocument = gql`
    mutation RemoveQueuePatient($input: RemoveQueuePatientInput!) {
  removeQueuePatient(input: $input) {
    ...PatientQueueWithPatientsFragment
  }
}
    ${PatientQueueWithPatientsFragmentFragmentDoc}`;
export type RemoveQueuePatientMutationFn = Apollo.MutationFunction<RemoveQueuePatientMutation, RemoveQueuePatientMutationVariables>;

/**
 * __useRemoveQueuePatientMutation__
 *
 * To run a mutation, you first call `useRemoveQueuePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveQueuePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeQueuePatientMutation, { data, loading, error }] = useRemoveQueuePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRemoveQueuePatientMutation(baseOptions?: Apollo.MutationHookOptions<RemoveQueuePatientMutation, RemoveQueuePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveQueuePatientMutation, RemoveQueuePatientMutationVariables>(RemoveQueuePatientDocument, options);
      }
export type RemoveQueuePatientMutationHookResult = ReturnType<typeof useRemoveQueuePatientMutation>;
export type RemoveQueuePatientMutationResult = Apollo.MutationResult<RemoveQueuePatientMutation>;
export type RemoveQueuePatientMutationOptions = Apollo.BaseMutationOptions<RemoveQueuePatientMutation, RemoveQueuePatientMutationVariables>;
export const MoveQueuePatientDocument = gql`
    mutation MoveQueuePatient($input: MoveQueuePatientInput!) {
  moveQueuePatient(input: $input) {
    ...PatientQueueWithPatientsFragment
  }
}
    ${PatientQueueWithPatientsFragmentFragmentDoc}`;
export type MoveQueuePatientMutationFn = Apollo.MutationFunction<MoveQueuePatientMutation, MoveQueuePatientMutationVariables>;

/**
 * __useMoveQueuePatientMutation__
 *
 * To run a mutation, you first call `useMoveQueuePatientMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMoveQueuePatientMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [moveQueuePatientMutation, { data, loading, error }] = useMoveQueuePatientMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMoveQueuePatientMutation(baseOptions?: Apollo.MutationHookOptions<MoveQueuePatientMutation, MoveQueuePatientMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MoveQueuePatientMutation, MoveQueuePatientMutationVariables>(MoveQueuePatientDocument, options);
      }
export type MoveQueuePatientMutationHookResult = ReturnType<typeof useMoveQueuePatientMutation>;
export type MoveQueuePatientMutationResult = Apollo.MutationResult<MoveQueuePatientMutation>;
export type MoveQueuePatientMutationOptions = Apollo.BaseMutationOptions<MoveQueuePatientMutation, MoveQueuePatientMutationVariables>;